import { FETCH_PROFILE_DETAILS } from '../utils/type';

const initialState = {
  userProfile: ''
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PROFILE_DETAILS:
      return {
        ...state,
        userProfile: action.data
      };
    default:
      return state;
  }
};

export default userReducer;
